import React from 'react';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { ThemeProvider as ThemeProviderBase, createTheme } from '@mui/material/styles';

import themeOptions from './themeOptions';

function ThemeProvider({ children }) {
  return (
    <ThemeProviderBase theme={createTheme(themeOptions)}>
      <ScopedCssBaseline enableColorScheme>{children}</ScopedCssBaseline>
    </ThemeProviderBase>
  );
}
export default ThemeProvider;
